// @ts-nocheck
/** Marka şeridi — Swiper başlatma (tema düzenleyicide yeniden kurulum). */

(function () {
  function num(v, fallback) {
    const x = parseFloat(String(v), 10);
    return Number.isFinite(x) ? x : fallback;
  }

  function destroy(root) {
    if (!root || !root._brandsSwiper) return;
    try {
      root._brandsSwiper.destroy(true, true);
    } catch {
      /* ignore */
    }
    root._brandsSwiper = null;
  }

  function collectRoots(target) {
    if (!target || !target.querySelectorAll) {
      return Array.from(document.querySelectorAll("[data-brands-root]"));
    }
    const list = Array.from(target.querySelectorAll("[data-brands-root]"));
    if (target.matches && target.matches("[data-brands-root]")) {
      list.unshift(target);
    }
    return list.length ? list : Array.from(document.querySelectorAll("[data-brands-root]"));
  }

  function init(root, swiperRetry) {
    if (!root) return;
    const el = root.querySelector(".section-brands__swiper");
    if (!el) return;

    if (typeof Swiper === "undefined") {
      const next = (swiperRetry || 0) + 1;
      if (next < 40) {
        setTimeout(() => init(root, next), 50);
      }
      return;
    }

    const slides = el.querySelectorAll(".swiper-slide");
    if (!slides.length) return;

    destroy(root);

    const gap = num(root.dataset.spaceBetween, 16);
    const sm = num(root.dataset.slidesSm, 2);
    const md = num(root.dataset.slidesMd, 3);
    const lg = num(root.dataset.slidesLg, 6);
    const autoplayOn = root.dataset.autoplay === "true";
    const autoplayMs = num(root.dataset.autoplayMs, 3000);
    const rewindOn = root.dataset.rewind === "true";

    const prevEl = root.querySelector("[data-brands-prev]");
    const nextEl = root.querySelector("[data-brands-next]");
    const hasNav = Boolean(prevEl && nextEl && slides.length > 1);

    root._brandsSwiper = new Swiper(el, {
      slidesPerView: sm,
      spaceBetween: gap,
      watchSlidesProgress: true,
      watchOverflow: true,
      grabCursor: true,
      speed: 450,
      rewind: rewindOn,
      breakpoints: {
        750: { slidesPerView: md, spaceBetween: gap },
        990: { slidesPerView: lg, spaceBetween: gap },
      },
      navigation: hasNav ? { prevEl, nextEl } : undefined,
      autoplay: autoplayOn
        ? { delay: autoplayMs, disableOnInteraction: true, pauseOnMouseEnter: true }
        : false,
    });
  }

  function refresh(event) {
    const roots = collectRoots(event && event.target);
    roots.forEach((root) => {
      destroy(root);
    });
    requestAnimationFrame(() => {
      roots.forEach((root) => init(root, 0));
    });
  }

  function boot() {
    collectRoots(null).forEach((root) => init(root, 0));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }

  ["shopify:section:load", "shopify:section:reorder", "shopify:section:select", "shopify:block:select"].forEach(
    (name) => {
      document.addEventListener(name, refresh);
    }
  );
})();
